module.exports = __webpack_public_path__ + "static/media/building3.b6a8515f.png";